export const laborInsuranceNumber = (
  office:
    | {
        laborInsuranceNumber0?: string;
        laborInsuranceNumber1?: string;
        laborInsuranceNumber2?: string;
        laborInsuranceNumber3?: string;
        laborInsuranceNumber4?: string;
      }
    | undefined
): string => {
  if (!office) {
    return '';
  }

  return [
    office.laborInsuranceNumber0,
    office.laborInsuranceNumber1,
    office.laborInsuranceNumber2,
    office.laborInsuranceNumber3,
    office.laborInsuranceNumber4
  ]
    .filter(v => v)
    .join('-');
};
